/* src/app/insights-joblist/insights-joblist.component.scss */
.insightJoblistsidenav {
  position: fixed;
  top: 0;
  right: -30%;
  width: 30%;
  height: 100%;
  background: #F2F2F2;
  color: #484b59;
  transition: 0.3s all ease-in;
  padding: 12px;
  z-index: 1000;
  overflow-y: auto;
}
.insightJoblistsidenav.open {
  right: 0;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.close-btn {
  background: none;
  border: none;
  color: #484b59;
  font-size: 20px;
  cursor: pointer;
}
.new-card {
  background-color: #fff;
  padding: 12px 12px;
  color: #484b59;
  font-size: 14px;
  margin-bottom: 6px;
}
.sticky-card {
  position: sticky;
  top: 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.slider-header-card {
  position: sticky;
}
.slider-header-card::before {
  position: absolute;
  top: -12px;
  left: 0;
  content: "";
  display: block;
  width: 100%;
  height: 12px;
  background-color: #F2F2F2;
}
.new-pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 6px 0px;
  align-items: center;
  margin-bottom: 6px;
  position: sticky;
  bottom: 0px;
  background: #ffffff;
  z-index: 3;
  margin-bottom: 0;
  box-shadow: 0 -6px 10px -10px rgba(0, 0, 0, 0.5);
}
.new-pagination::after {
  position: absolute;
  bottom: -12px;
  left: 0;
  content: "";
  display: block;
  width: 100%;
  height: 12px;
  background-color: #F2F2F2;
}
.activepage {
  border-radius: 4px;
  border: 1px solid #CCCBCB;
  background: #FCFCFC;
  display: inline-flex;
  padding: 6px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 40px;
  height: 30px;
  font-size: 14px;
}
button {
  border: 0;
  outline: none;
}
button:disabled {
  cursor: not-allowed;
}
.spinner-border {
  width: 4rem;
  height: 4rem;
}
.h-100 {
  height: 100%;
  display: block;
}
.h97 {
  height: calc(100% - 97px);
  overflow-y: auto;
  position: relative;
}
.h97::-webkit-scrollbar {
  width: 3px !important;
  position: absolute;
  right: 0;
}
.h97 ::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
}
.h97::-webkit-scrollbar-thumb {
  background: #c9c7c7 !important;
}
.h97::-webkit-scrollbar-thumb:hover {
  background: #979797 !important;
}
::ng-deep .mat-tooltip {
  white-space: pre-line !important;
}
:ng-deep ngb-pagination ul.pagination {
  justify-content: center;
}
/*# sourceMappingURL=insights-joblist.component-DCIENLCN.css.map */
